"use client";

import { useEffect, useState } from "react";

import TwoColorText from "./TwoColorText";
import { motion } from "framer-motion";

export default function HomeText({ family, isFirst, windowWidth }) {
  return (
    <motion.div
      className="flex flex-col items-center justify-center text-center"
      style={{ translateY: 30, opacity: 0 }}
      initial={{ translateY: 30, opacity: 0 }}
      whileInView={{ translateY: 0, opacity: 1 }}
      viewport={{ once: true, amount: 0.8 }}
      transition={{
        duration: 0.5,
      }}
    >
      <TwoColorText
        text={family.name}
        font={family}
        color={family.secondaryAccentColor}
        bgColor={family.accentColor}
        classes={isFirst ? "sm:mt-16" : ""}
        skipMultiply={family.skipMultiplyOnMainPage}
        windowWidth={windowWidth}
      />
      <TwoColorText
        text={family.subtitle}
        font={family}
        color={family.secondaryAccentColor}
        bgColor={family.accentColor}
        minScale={22}
        maxScale={20}
        minScaleSmall={15}
        maxScaleSmall={12}
        skipMultiply={family.skipMultiplyOnMainPage}
        windowWidth={windowWidth}
      />
    </motion.div>
  );
}
